import { Dispatch, AnyAction } from 'redux';
import { TRIAGE_ROUTES } from 'screens/TriageGyant/constants';
import { push } from 'connected-react-router';

export const navigateToEVisit = (dispatch: Dispatch<AnyAction>) => {
  dispatch(push(TRIAGE_ROUTES.SYMPTOM_CHECKER));
};

export * from './actions.common';
